module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/parts/parts.component.scss
// module id = ./src/app/pages/parts/parts.component.scss
// module chunks = main